import { useEffect, useState } from "react";
import { Alert, type AlertColor, Snackbar } from "@mui/material";

const GLOBAL_SNACKBAR_EVENT = "global-snackbar";

interface SnackbarPayload {
  message: string;
  severity: AlertColor;
}

// eslint-disable-next-line react-refresh/only-export-components
export function dispatchGlobalError(message: string) {
  window.dispatchEvent(
    new CustomEvent(GLOBAL_SNACKBAR_EVENT, {
      detail: { message, severity: "error" } satisfies SnackbarPayload,
    }),
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function dispatchGlobalSuccess(message: string) {
  window.dispatchEvent(
    new CustomEvent(GLOBAL_SNACKBAR_EVENT, {
      detail: { message, severity: "success" } satisfies SnackbarPayload,
    }),
  );
}

const GlobalSnackbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState<SnackbarPayload>({
    message: "",
    severity: "error",
  });

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<SnackbarPayload>).detail;
      setPayload(detail);
      setOpen(true);
    };
    window.addEventListener(GLOBAL_SNACKBAR_EVENT, handler);
    return () => window.removeEventListener(GLOBAL_SNACKBAR_EVENT, handler);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={payload.severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {payload.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
